import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  ApiVisa,
  TaxCodeCfgService,
  TaxCodeContainerModel
} from 'blg-akaun-ts-lib';
import { ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../shared-utilities/visa';


@Component({
  selector: 'appSST',
  templateUrl: './sst.component.html',
  styleUrls: ['./sst.component.css']
})
export class SelectSSTDropDownComponent implements OnInit, OnDestroy {

  @Input() sst: FormControl;
  apiVisa = AppConfig.apiVisa;
  @Output() sstChange = new EventEmitter<FormControl>();
  @Output() sstContainer = new EventEmitter<TaxCodeContainerModel>();

  private subs = new SubSink();

  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<TaxCodeContainerModel[]> = new ReplaySubject<TaxCodeContainerModel[]>(1);
  sstList: TaxCodeContainerModel[];

  constructor( 
    private taxService: TaxCodeCfgService
  ) {}

  ngOnInit() {
    this.subs.sink = this.taxService.get(this.apiVisa).subscribe(
      {next: resolve => {
        this.sstList = resolve.data.filter(s => s.bl_fi_cfg_tax_code.tax_gst_type);
        this.filteredOptions$.next(this.sstList);
      }});
    // if (this.currency.value) {
    //   this.subs.sink = this.currencyService.getByGuid(this.currency.value, this.apiVisa).subscribe( resolved => {
    //     this.branchList = [resolved.data];
    //     this.filteredOptions$.next([resolved.data]);
    //     this.onSelect(resolved.data.bl_fi_mst_branch.guid.toString());
    //   });
    // }
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterSST(resolve)});
  }

  filterSST(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.sstList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.sstList.filter(s => s.bl_fi_cfg_tax_code.tax_code.toLowerCase().includes(search.toLowerCase().toString()));
      this.filteredOptions$.next(filter);
    }
  }

  onSelectionChange(e: string) {
    const container = this.sstList.find(c => c.bl_fi_cfg_tax_code.tax_code === e);
    this.sstContainer.emit(container);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
